(function ($) {

  // fix for lauterate modal not giving visual feedback
  // English

  // if ($('#wpcf7-f19139-p19173-o1').length !== 0) {

  //   document.addEventListener('wpcf7submit', function (event) {
  //     $('.wpcf7-response-output').toggleClass('wpcf7-display-none');
  //     if (event.detail.apiResponse.status === "validation_failed") {
  //       $('.wpcf7-response-output').text('Please ensure all required fields are filled in and try again.');
  //     } else {
  //       $('.wpcf7-response-output').text('Application submitted.');
  //     }
  //   }, { passive: true });

  //   // var lauFormEnglish = document.querySelector('#wpcf7-f19139-p19173-o1');
  //   // lauFormEnglish.querySelector("wpcf7submit").onclick = function () {
  //   //   console.log('test');
  //   // }

  //   // // lauFormEnglish.addEventListener('wpcf7submit', function (event) {
  //   // //   //
  //   // // }, { passive: true });
  // }

  // if ($('#wpcf7-f19145-p19244-o1').length !== 0) {
  //   var lauFormWelsh = document.querySelector('#wpcf7-f19145-p19244-o1');
  //   lauFormWelsh.addEventListener('wpcf7submit', function (event) {
  //     $('.wpcf7-response-output').toggleClass('wpcf7-display-none');
  //     if (event.detail.apiResponse.status === "validation_failed") {
  //       $('.wpcf7-response-output').text('Sicrhewch fod yr holl feysydd gofynnol yn cael eu llenwi a rhoi cynnig arall arni.');
  //       // google translate
  //     } else {
  //       $('.wpcf7-response-output').text('Cais wedi\'i gyflwyno\'n llwyddiannus.');
  //     }
  //   }, { passive: true });
  // }

  // Generate marker
  function add_marker($marker, map) {
    // var
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    // create marker
    var map_pin = $('#map-pin').val();

    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      icon: map_pin
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function () {

        infowindow.open(map, marker);

      });
    }
  }

  // Center map
  function center_map(map) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {

      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

      bounds.extend(latlng);

    });

    // only 1 marker?
    if (map.markers.length === 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }

  }


  // Generate map
  function new_map($el) {
    // var
    var $markers = $el.find('.marker');

    // vars
    var args = {
      zoom: 5,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      styles: [
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f6f6f6"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#f8f8f8"
            }
          ]
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#aa9a9a"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#93b7bb"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#7d7991"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#e89ba7"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#fefefe"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#e9e9e9"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffcc4f"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#ffcc4f"
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffcc4f"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#7d7991"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#ff0000"
            },
            {
              "visibility": "off"
            }
          ]
        }
      ]
    };

    // create map
    var map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
      add_marker($(this), map);
    });

    // center map
    center_map(map);

    // return
    return map;
  }


  var map = null;

  $(document).ready(function () {

    $('.google-map').each(function () {

      if ($(window).width() > 991) {
        var map_width = $('.google-map').width();
        $('.google-map').height(map_width);
      }

      // create map
      map = new_map($(this));

    });

  });


})(jQuery);


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  var currentWindowSize = $(window).width();

  //-- Functions

  function checkDefiniteResize() {
    var definiteResize = false;

    if (currentWindowSize !== $(window).width()) {
      definiteResize = true;
    }

    currentWindowSize = $(window).width();
    return definiteResize;
  }

  function getWindowWidth() {
    var bodyOverflowX = $('body').css('overflow-x');
    var bodyOverflowY = $('body').css('overflow-y');
    $('body').css('overflow', 'hidden');
    var windowWidth = $(window).width();
    $('body').css({
      'overflowX': bodyOverflowX,
      'overflowY': bodyOverflowY
    });

    return windowWidth;
  }

  var windowWidth = getWindowWidth();


  // match element heights
  function matchHeights() {
    if (windowWidth > 767) {
      $('.headerMatch').matchHeight({byRow: true});
      $('.headerMatch').css('opacity', '1');

      $('.bannerMatch').matchHeight({byRow: true});
      $('#home-banner .item').height($('#home-banner').height());
      // $('.bannerMatch').css('opacity', '1');

      $('.homeContentMatch').matchHeight();
      $('.homeContentMatch').css('opacity', '1');

      $('.teamMember .inr .text .position').matchHeight();
      $('.teamMember .inr .text .position').matchHeight();
      $('.team').css('opacity', '1');

      $('.blogHeight').matchHeight({byRow: false});
      $('.blog-item .content .inr .title, .news-item .content .inr .title').matchHeight();
      $('.blog').css('opacity', '1');

      $('.event-title-match').matchHeight({byRow: true});
      $('.event .content').matchHeight({byRow: true});
      $('.events').css('opacity', '1');

      $('.eventHeight').matchHeight({byRow: true});
      $('.eventHeight').css('opacity', '1');

      $('.fileMatch').matchHeight({byRow: true});
      $('.contactMatch').matchHeight({byRow: true});
      $('form label').matchHeight({byRow: true});

      $('#groups .group .inr h4').matchHeight({byRow: true});

    } else {
      $('.headerMatch').css('opacity', '1');
      $('.homeContentMatch').css('opacity', '1');
      $('.news').css('opacity', '1');
      $('.blog').css('opacity', '1');
      $('#event-filters').css('opacity', '1');
      $('.events').css('opacity', '1');
      $('.eventHeight').css('opacity', '1');
      $('.team').css('opacity', '1');
      // $('.social').css('opacity', '1');
    }

    if (windowWidth > 991) {
      $('.eventContentMatch').matchHeight({byRow: true});
      $('#event-filters').css('opacity', '1');

      $('.newsHeight').matchHeight({byRow: true});
      $('.news').css('opacity', '1');
    } else {
      $('.news').css('opacity', '1');
      $('#event-filters').css('opacity', '1');
    }

    // Match social boxes
    if (windowWidth > 767) {
      // var instaWidth = $('.socialMatch.instagram .image').width();
      // var instaHeight = $('.socialMatch.instagram .image').outerHeight();

      // $('.instaMatch').height(instaWidth);
      // $('.socialMatch').innerHeight(instaWidth);
      $('.socialMatch .inr').matchHeight();
      $('.social').css('opacity', '1');
    } else {
      $('.social').css('opacity', '1');
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages

        var windowWidth = getWindowWidth();


        // Toggle mobile menu
        $('#toggle-mobile-menu').click(function () {
          $('#mobile-menu, #toggle-mobile-menu').toggleClass('open');
          $('#mobile-menu').stop().slideToggle('slow');
        });


        // Toggle mobile menu children
        $('#mobile-menu .navbar-nav-mobile > li .toggle').click(function () {
          $(this).toggleClass('open');
          $(this).next().stop().slideToggle();
        });


        // Expand mobile sub-menus if active page is within sub-menu
        $('#mobile-menu .navbar-nav-mobile > li').each(function (i, li) {
          if ($(li).hasClass('current-page-ancestor') && !$(li).hasClass('menu-item-81')) {
            var get_id = $(li).attr('id');
            var ancestor_id = get_id.replace('menu-item-', '');

            $(li).find('#toggle-' + ancestor_id).addClass('open');
            $(li).find('#toggle-' + ancestor_id).next().css('display', 'block');

            $(li).find('#toggle-' + ancestor_id).next().children().each(function (j, li2) {

              var get_id = $(li2).attr('id');
              var ancestor_id = get_id.replace('menu-item-', '');

              if ($(li2).hasClass('current_page_ancestor')) {
                $(li2).find('#toggle-' + ancestor_id).addClass('open');
                $(li2).find('#toggle-' + ancestor_id).next().css('display', 'block');
              }
            });
          }
        });


        // Toggle mobile search
        // $('#mobile-search-toggle').click(function(){
        //   $('#mobile-search').stop().slideToggle('slow');
        // });


        // Add id's to submenu items to correspond to parent li items
        $('#sidebarMenu ul.side-menu > li.menu-item-has-children').each(function (index, el) {
          var get_id = $(this).attr('id');
          var id = get_id.replace('item-', '');

          // console.log('get_id ' + get_id);
          // console.log('id ' + id);

          $(this).next('ul').attr('id', 'sub-' + id);

          if ($(this).hasClass('current-menu-item')) {
            $(this).next().addClass('open').css('display', 'block');
            $(this).find('#subMenuToggle').addClass('open');
          }
        });


        // Toggle sidebar menu
        $('#sidebarMenu ul.side-menu li #subMenuToggle').click(function () {
          var toggle_id = $(this).data('id');

          $(this).toggleClass('open');
          // $('ul#' + toggle_id ).stop().slideToggle();
          $('ul#sub-' + toggle_id).stop().slideToggle();
        });

        // Expand sidebar sub-menu if active page is within sub-menu
        $('#sidebarMenu ul.side-menu > li').each(function (index, el) {
          if ($(this).hasClass('current-page-ancestor')) {
            var get_ancestor_id = $(this).attr('id');
            var ancestor_id = get_ancestor_id.replace('item-', '');

            // console.log(ancestor_id);

            $(this).find('#subMenuToggle').addClass('open');
            $(this).parent().find('ul#sub-item-' + ancestor_id).addClass('open').css('display', 'block');
            // $('li.current-page-ancestor ul').css('display', 'block');
          }
        });

        // Add custom class to sidebar menu if menu has multiple levels to style differently
        // if( $('#sidebarMenu ul.menu').length ) {

        //   var sidebar_height = $('#sidebarMenu').height();
        //   var submenu_height = $('li.current_page_item ul.sub-menu').height();
        //   var sum = Math.round( sidebar_height + submenu_height + 40 );
        //   var new_sidebar_height = Math.ceil( sum / 10) * 10;

        //   // if( $('#sidebarMenu ul.menu > li > ul.sub-menu > li').hasClass('current-menu-item') ) {
        //   if( $('#sidebarMenu ul.menu > li > ul.sub-menu').length ) {

        //     $('#sidebarMenu ul.menu').addClass('multi-level-menu');

        //     $('#sidebarMenu').height( new_sidebar_height );

        //     $('#sidebarMenu ul.menu.multi-level-menu').css('opacity', '1');
        //   } else {
        //     // $('#sidebarMenu ul.menu').removeClass('multi-level-menu');

        //     // $('#sidebarMenu').height( new_sidebar_height );

        //     $('#sidebarMenu ul.menu').css('opacity', '1');
        //   }
        // }


        // Events AJAX pagination
        $('.remaining-events').on('click', '#pager a', function (e) {
          e.preventDefault();
          var link = $(this).attr('href');
          var event_boxes = $('.remaining-events .event');
          var pager = $('#pager');

          event_boxes.each(function () {
            var event = $(this);
            var index = event_boxes.index(event);

            setTimeout(function () {
              event.find('.image').css('opacity', '0');
              event.find('.content').css('opacity', '0');
              event.find('#preloader').css('opacity', '1');
            }, index * 80);
          });

          $('html, body').animate({
            scrollTop: $("#filter-results").offset().top - 150
          }, 500);


          $.post(link, function (data) {
            var content = $(data).find('#filter-results');
            var pagination = $(data).find('#pager');

            pager.html(pagination.html());

            // pager.css('opacity', '0');
            // pager.html( pagination.html() );
            // pager.css('opacity', '1');

            setTimeout(function () {
              $('#filter-results').html(content.html());
              $('#filter-results .event .event-title-match').matchHeight({byRow: true});
              $('#filter-results .event .content').matchHeight({byRow: true});

              event_boxes.each(function () {
                var event = $(this);
                var index = event_boxes.index(event);

                setTimeout(function () {
                  event.find('#preloader').css('opacity', '0');
                  event.find('.image').css('opacity', '1');
                  event.find('.content').css('opacity', '1');
                }, index * 80);
              });

            }, 150);

          });

        });


        // Default carousel
        var default_image_banner = $('#default-image-carousel');
        if (default_image_banner.children().length > 1) {
          default_image_banner.owlCarousel({
            // loop:true,
            margin: 10,
            items: 1,
            dots: true,
            autoplay: true,
            autoplayTimeout: 6500,
          });
        }


        // Latest Event carousel
        var slider_events_banner = $('#slider-events-banner');
        if (slider_events_banner.children().length > 1) {
          slider_events_banner.on('changed.owl.carousel', function (event) {
            slider_events_banner.css('opacity', '1');
            slider_events_banner.find('.owl-controls').css('opacity', '1');
          }).owlCarousel({
            // loop:true,
            margin: 10,
            items: 1,
            dots: true,
            autoplay: true,
            autoplayTimeout: 6500,
          });
        }


        // Gallery
        $(function () {
          var GammaSettings = {
            viewport: [{
              width: 1500,
              columns: 5
            }, {
              width: 1200,
              columns: 4
            }, {
              width: 800,
              columns: 3
            }, {
              width: 0,
              columns: 2
            }]
          };
          Gamma.init(GammaSettings);
        });


        // Remove all <br> tags from forms - sometimes get inserted with contact form 7
        $('.wpcf7 form br').remove();


        // Remvoe placeholder from text area on click - doesn't get removed on some browsers
        /*$('.wpcf7 form input, .wpcf7 form textarea').on( 'click', function( event ) {
          $(this).removeAttr('value');
          $(this).off( event ); // Stop event after first trigger
        });*/

        // Display CF7 messages in modal window
        $('.wpcf7-response-output').wrap('<div id="wpcf7-response-modal" class="modal"><div class="modal-content"></div></div>');
        $('<button type="button" class="btn btn-default btn-l-blue" data-dismiss="modal">Close</button>').insertAfter('#wpcf7-response-modal .modal-content .wpcf7-response-output');

        $('.wpcf7-submit').click(function (event) {
          $(document).ajaxComplete(function () {
            // var response = $('.wpcf7-response-output').html();
            $('#wpcf7-response-modal').modal();
          });
        });

        if ($('body.writers-tour-application-form').hasClass('cy')) {
          $('#writers-tour-form form #submit-welsh').val('Cyflwyno');

          $('.wpcf7-submit').click(function (event) {
            $('#writers-tour-form form #submit-welsh').val('Cyflwyno');
          });

        } else {
          $('#writers-tour-form form #submit').val('Submit');

          $('.wpcf7-submit').click(function (event) {
            $('#writers-tour-form form #submit').val('Submit');
          });
        }

        if ($('body.page-template-template-event-form').hasClass('cy')) {
          $('#list-event-form form #submit-welsh').val('Cyflwyno');

          $('.wpcf7-submit').click(function (event) {
            $('#list-event-form form #submit-welsh').val('Cyflwyno');
          });

        } else {
          $('#list-event-form form #submit').val('Submit');

          $('.wpcf7-submit').click(function (event) {
            $('#list-event-form form #submit').val('Submit');
          });
        }

        // Initialise selectric
        if ($('.page-template-template-writers-form select').length || $('.page-template-template-event-form select').length) {
          $('.wpcf7 select').on('selectric-init', function () {
            if (getLangCode === "en") {
              contact_label = "Select...";
            } else {
              contact_label = "Dewiswch...";
            }
            $('.wpcf7 .selectric .label').html(contact_label);

          }).selectric({
            responsive: true,
            disableOnMobile: false,
          });
        }

        if ($('#event-filters form select').length) {
          $('#event-filters #event-filter select').on('selectric-init', function () {
          }).selectric({
            maxHeight: 300,
            responsive: true,
            disableOnMobile: false,
          });

          $('#event-filters form').css('opacity', '1');
        }

        if ($('.product .booking .variations #price-options').length) {
          $('.product .booking .variations #price-options').selectric({
            responsive: true,
            disableOnMobile: false,
          });
        }

        if ($('.product .booking .variations .input-text.qty.text').length) {
          $('.product .booking .variations .input-text.qty.text').spinner();
        }

        $('#reset-form').click(function () {
          $('#event-filter')[0].reset();
          $('#event-filters select').selectric('refresh');
        });


        // Hide/show event price/booking fields
        // Custom radio buttons
        $('input:radio').iCheck({
          // checkboxClass: 'icheckbox_flat-aero',
          radioClass: 'iradio_flat-aero'
        });

        $('input:radio').on('ifChecked', function (event) {
          get_value = event.currentTarget.value;

          if (get_value === 'No' || get_value === 'Nac ydi') {
            $('#list-event-form #price, #list-event-form #booking-method').css('opacity', '1');

            // Change price/booking fields to required when visible
            $('input[name="ticket-price"]').prop('required', true);
            $('input[name="booking-method"]').prop('required', true);

            // Hide/show URL/Telephone field
            $('#list-event-form #booking-method .selectric-items ul li').click(function () {
              if ($(this).text() !== 'Not Required') {
                $('#list-event-form #url-tel').css('opacity', '1');

                // Change price/booking fields to required when visible
                $('input[name="url-telephone"]').prop('required', true);

              } else if ($(this).text() === 'Not Required') {
                $('#list-event-form #url-tel').css('opacity', '0');

                $('input[name="url-telephone"]').prop('required', false);
              }
            });

          } else if (get_value === 'Yes' || get_value === 'Ydi') {
            $('#list-event-form #price, #list-event-form #booking-method, #list-event-form #url-tel').css('opacity', '0');

            $('input[name="ticket-price"]').prop('required', false);
            $('input[name="booking-method"]').prop('required', false);
          }
        });


        // Blog category filter
        $('#blog-category').on('selectric-init', function () {
          $('form#category-select').css('opacity', '1');
        }).selectric({
          responsive: true,
          disableOnMobile: false,
        });


        // Event filters responsive toggle
        if ((windowWidth <= 991)) {
          $('#event-filters .h2 #toggle').click(function () {
            $(this).toggleClass('open');
            $('#event-filter').stop().slideToggle();
          });
        }


        // Writer Groups MixItUp
        var groups = $('#groups');
        var filters = $('#alphabet-filter');
        var letter_filter = $('#alphabet-filter .letters .letter');
        var letter_filters = [];
        var group = $('#groups .group');

        // Create an array of group letters
        letter_filter.each(function (i) {
          letter_filters.push($(this).attr('data-filter'));
        });

        // Instantiate MixItUp:
        groups.mixItUp({
          controls: {
            toggleFilterButtons: true,
            toggleLogic: 'and'
          },
          callbacks: {
            // onMixLoad: function(state, futureState){
            //   filters.css('opacity', '0');
            // },
            onMixStart: function (state, futureState) {
              $('#groups .group').matchHeight();
            },
            onMixEnd: function (state) {
              // Loop through each group and add an active class to groups with display:inline-block
              // declaration. This will make it easier to target the visible groups in the function below
              group.each(function (i) {
                if ($(this).attr('style').indexOf('display: inline-block') !== -1) {
                  $(this).addClass('active-group');
                } else {
                  $(this).removeClass('active-group');
                }
              });

              $.each(letter_filters, function (i, val) {
                var filter_count = $('#groups .group.active-group' + val).length;
                var empty_filter = letter_filter.filter('[data-filter="' + val + '"]');

                if (filter_count === 0) {
                  empty_filter.addClass('disabled');
                  filters.css('opacity', '1');
                } else {
                  empty_filter.removeClass('disabled');
                  filters.css('opacity', '1');
                }
              });

            }
          }
        });


        // Products MixItUp
        $('#product-mix').mixItUp({
          controls: {
            toggleFilterButtons: true,
            toggleLogic: 'and'
          },
          callbacks: {
            onMixStart: function (state, futureState) {
              $('.product h4').matchHeight({byRow: true});
            }
          }
        });

        // AJAX load more groups
        $('#btn-load-more').on('click', function () {
          var $load_button = $(this);
          $(this).hide();

          var action = 'load_more_groups';
          var container = '#groups';
          var $spinner = $('<div class="spinner-wrap"><div class="spinner"><div class="double-bounce1"></div><div class="double-bounce2"></div></div></div>');

          $load_button.after($spinner);

          var page = parseInt($(this).attr('data-page'));
          var max_pages = $(this).attr('data-max-pages');
          var data = {
            'action': action,
            'security': nonce_string,
            'page': page + 1,
            'per_page': max_pages
          };

          $.post(ajaxurl, data, function (response) {
            if (response !== '') {
              $spinner.remove();

              var $items = $(response);

              $(container).mixItUp('append', $items);

              if ((parseInt(page) + 1) < max_pages) {
                $load_button.show();
              }
            }
          });

          $(this).attr('data-page', page + 1);
        });


        function fetchUsedDays() {
          var usedDays = [];

          var data = {
            'action': 'lit_wales_fetch_events',
            'security': nonce_string
          };

          $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: data,
            success: function (response) {
              if (response.success) {
                $.each(response.data, function (index, value) {
                  usedDays[new Date(value)] = new Date(value);
                });

                usedDays = response.data;

                return usedDays;
              }
            }
          });

          return usedDays;
        }


        // Date and time pickers

        if ($('#event-filters .datepicker').length) {
          // var current_dates = fetchUsedDays();

          $('#event-filters .datepicker').datepicker({
            showOn: 'focus',
            dateFormat: 'dd/mm/yy',
            showOtherMonths: true,
            selectOtherMonths: true,
            // beforeShowDay: function( date ) {
            //   var highlight = current_dates[date];
            //   if( highlight ) {
            //     return [true, "event", 'Tooltip text'];
            //   } else {
            //     return [true, '', ''];
            //   }
            // },
            firstDay: 1,
            // onChangeMonthYear: function( year, month, inst  ) {
            // console.log( inst );
            // }
          });
        }


        // add generic datepickers
        if ($('.datepicker').length) {
          $('.datepicker').datepicker({
            showOn: 'focus',
            dateFormat: 'dd/mm/yy',
          });
        }


        // Initialise timepicker, if exists
        if ($('.timepicker').length) {
          $('.timepicker').timepicker({
            showOn: 'focus',
          });
        }


        // Word Counters
        if ($('.count250').length) {
          $('.count250').textcounter({type: 'word', max: 250});
        }
        if ($('.count200').length) {
          $('.count200').textcounter({type: 'word', max: 200});
        }
        if ($('.count150').length) {
          $('.count150').textcounter({type: 'word', max: 150});
        }
        if ($('.count100').length) {
          $('.count100').textcounter({type: 'word', max: 100});
        }
        if ($('.count50').length) {
          $('.count50').textcounter({type: 'word', max: 50});
        }


        // Toggle faq answers
        $('.question-toggle').click(function () {
          var questionID = $(this).attr('data-id');
          var questionTopic = $(this).attr('data-type');

          $(this).parent().parent().toggleClass('open');
          $(this).toggleClass('open');
          $('#answer-' + questionTopic + '-' + questionID).stop().slideToggle();
        });


        // Set faq question toggle height to same height as question to ensure central alignment
        if (windowWidth > 767) {
          var questionHeight = $('.question').height();

          $('.question-toggle').css({
            'height': questionHeight,
          });
        }


        // Toggle team profiles
        $('.teamButton').click(function () {
          var profileID = $(this).attr('data-id');
          var thisProfile = $('#teamProfile-' + profileID);
          var thisBtn = $('#btn-' + profileID);

          $(this).toggleClass('open');
          $(this).parent().parent().toggleClass('open');
          $(this).closest('.team.row').toggleClass('open-row');

          thisProfile.stop().slideToggle();
          thisProfile.toggleClass('active');

          if ($(this).hasClass('open')) {
            if ($('body').hasClass('cy')) {
              $(this).text('Diwedd');
            } else {
              $(this).text('Close');
            }
            $('.teamButton').not($(this)).addClass('disabled');
          } else {
            if ($('body').hasClass('cy')) {
              $(this).text('Darllenwch y Proffil');
            } else {
              $(this).text('Read Profile');
            }
            $('.teamButton').not($(this)).removeClass('disabled');
          }

          var nearestClearfix = $('#teamMember-' + profileID).nextAll('.clearfix:visible').eq(0);
          thisProfile.insertAfter(nearestClearfix);
        });

        // Close team profiles
        $('.closeProfile').click(function () {
          var thisID = $(this).attr('data-id');

          $('#teamProfile-' + thisID).stop().slideToggle();
          $('#teamProfile-' + thisID).toggleClass('active');

          $('#teamMember-' + thisID + ' .inr').toggleClass('open');
          $('#btn-' + thisID).toggleClass('open');

          if ($('#btn-' + thisID).hasClass('open')) {
            if ($('body').hasClass('cy')) {
              $('#btn-' + thisID).text('Diwedd');
            } else {
              $('#btn-' + thisID).text('Close');
            }
            $('.teamButton').not($('#btn-' + thisID)).addClass('disabled');
          } else {
            if ($('body').hasClass('cy')) {
              $('#btn-' + thisID).text('Darllenwch y Proffil');
            } else {
              $('#btn-' + thisID).text('Read Profile');
            }
            $('.teamButton').not($('#btn-' + thisID)).removeClass('disabled');
          }
        });


        function stretchProfileMargins() {
          var windowWidth = $(window).width();
          var profileWidth = $('.teamProfile').width();
          var profileMargin = (windowWidth - (profileWidth - 30));
          var marginLeft = profileMargin / 2;
          var marginRight = profileMargin / 2;

          $('.teamProfile').css({
            'marginLeft': '-' + marginLeft + 'px',
            'marginRight': '-' + marginRight + 'px'
          });
        }

        stretchProfileMargins();


        function onReadyResponsive(initial, windowWidth, definiteResize) {
          matchHeights();
        }

        function onLoadResponsive(initial, windowWidth, definiteResize) {
          matchHeights();
          // menuPadding();
          // alphaFilterMargins();
        }

        $(window).load(function () {
          onLoadResponsive(true, getWindowWidth());
        });

        $(window).resize(function () {
          var windowWidth = getWindowWidth();
          onLoadResponsive(false, windowWidth);
          onReadyResponsive(false, windowWidth);
        });


      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS

        // Home banner
        var home_banner = $('#home-banner');
        if (home_banner.children().length > 1) {
          home_banner.on('initialized.owl.carousel', function () {
            $('#banner-events').css('opacity', '1');
          }).owlCarousel({
            loop: true,
            margin: 10,
            items: 1,
            dots: true,
            autoplay: true,
            autoplayTimeout: 5500,
          });

        } else {
          $('#banner-events').css('opacity', '1');
        }

        // Home events banner
        var home_events = $('#home-events');
        if (home_events.children().length > 1) {
          home_events.owlCarousel({
            loop: true,
            margin: 10,
            items: 1,
            dots: false,
            // autoplay: true,
            // autoplayTimeout: 6500,
          });

          $('#home-events-nav .btn.next').click(function () {
            home_events.trigger('next.owl.carousel');
          });
          $('#home-events-nav .btn.prev').click(function () {
            home_events.trigger('prev.owl.carousel');
          });
        }

        const videoEmbed = document.querySelector('.video-embed');
        if (home_banner && videoEmbed) {
          window.onYouTubeIframeAPIReady = function () {
            var player = new YT.Player(videoEmbed, {
              videoId: videoEmbed.dataset.video,
              playerVars: {
                autoplay: 1,
                controls: 0,
                rel: 0,
                loop: 1,
                playlist: videoEmbed.dataset.video
              },
              events: {
                onReady: function (e) {
                  e.target.playVideo();
                }
              }
            });
          };
        }

      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // @see https://docs.gravityforms.com/gform_file_upload_markup/
  gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl) {
    var formId = up.settings.multipart_params.form_id;
    var fieldId = up.settings.multipart_params.field_id;
    html = '<strong>' + file.name + "</strong> <a class='gform_delete' onclick='gformDeleteUploadedFile(" + formId + "," + fieldId + ", this);' title='" + strings.delete_file + "'><small>remove</small></a>";

    return html;
  });

})(jQuery); // Fully reference jQuery after this point.
